<template>
  <div>
    <b-card title="Genel Bilgiler">
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <service-files-title-card />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <SFDocumentGroupsSelectCard />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <service-files-notes-card />
        </b-col>
      </b-row>
    </b-card>
    <b-card title="Doküman Bilgileri">
      <b-row>
        <template v-if="controlVersionFiles">
          <b-col
            v-if="itemData.id"
            cols="12"
            md="12"
          >
            <SFilesVOVTSelectCard />
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <SFVOBriefDescriptionCard />
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <SFVORelaseNotesCard />
          </b-col>
          <b-col
            v-if="itemData.id"
            cols="12"
            md="12"
          >
            <SFilesVOStatusSelectCard />
          </b-col>
        </template>
        <b-col
          cols="12"
          md="12"
        >
          <service-files-file-card />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import ServiceFilesTitleCard from '@/views/Services/Files/Elements/TitleCard.vue'
import SFDocumentGroupsSelectCard from '@/views/Services/Files/Elements/DocumentGroupsCard.vue'
import ServiceFilesNotesCard from '@/views/Services/Files/Elements/NotesCard.vue'
import SFilesVOVTSelectCard from '@/views/Services/Files/Elements/VersionOptions/VersionTypeSelect.vue'
import SFVOBriefDescriptionCard from '@/views/Services/Files/Elements/VersionOptions/BriefDescription.vue'
import SFVORelaseNotesCard from '@/views/Services/Files/Elements/VersionOptions/ReleaseNotes.vue'
import ServiceFilesFileCard from '@/views/Services/Files/Elements/FileCard.vue'
import SFilesVOStatusSelectCard from '@/views/Services/Files/Elements/VersionOptions/StatusSelect.vue'

export default {
  name: 'ServiceFilesItemForm',
  components: {
    SFilesVOStatusSelectCard,
    ServiceFilesFileCard,
    SFVORelaseNotesCard,
    SFVOBriefDescriptionCard,
    SFilesVOVTSelectCard,
    ServiceFilesNotesCard,
    SFDocumentGroupsSelectCard,
    ServiceFilesTitleCard,
    BCard,
    BRow,
    BCol,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['serviceFiles/dataItem']
    },
    controlVersionFiles() {
      // userData içindeki packageLimits array'inde subject'i SERVICE_FILE_VERSIONS olan elemanın limit'i 1 ise true, değilse false döndürür
      if (
        this.userData
          && Array.isArray(this.userData.packageLimits)
      ) {
        const found = this.userData.packageLimits.find(
          item => item.subject === 'SERVICE_FILE_VERSIONS',
        )
        return found && found.limit === 1
      }
      return false
    },
  },
}
</script>
